import script from "./InspectionForm.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectionForm.vue?vue&type=script&setup=true&lang=js"

import "./InspectionForm.vue?vue&type=style&index=0&id=70192864&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70192864"]])

export default __exports__